import { P2GLink, P2GText } from '@parcel2go/core-ui';
import { TranslationNamespaces } from '~/lib/constants';
import { Trans, useTranslation } from 'react-i18next';

type props = {
  field: string;
  onUseOriginDetails?: (field: string) => void;
  usableOriginDetails?: string[];
  wrapper: (x: JSX.Element) => JSX.Element;
};

export default function UseDetails({ field, usableOriginDetails, onUseOriginDetails, wrapper }: props) {
  const { t } = useTranslation([TranslationNamespaces.CHECKOUT]);

  if (!usableOriginDetails?.includes(field)) {
    return null;
  }

  return wrapper(
    <P2GText>
      <Trans
        i18nKey={`ADDRESS_BUTTON_USE_ORIGIN_${field.toUpperCase()}`}
        t={t}
        defaults="Not sure? Use <0>my {{field}}</0> if needed."
        values={{ field: field }}
        components={[<P2GLink onClick={() => onUseOriginDetails?.(field)} />]}
      />
    </P2GText>
  );
}
